<template>
  <section>
    <div class='mock'>
      <div class='main'>
        <div class="loading">~ no data ~</div>
      </div>
    </div>
  </section>
</template>

<script>
    export default {
        name: 'nodata'
    }
</script>

<style scoped>
  section{
    width:100%
  }
  .mock{
  }
  .main{
    color:#5cb85c;
    text-align:center;
  }
  .loading{
    font-size: 1.2rem;
  }
</style>



// WEBPACK FOOTER //
// src/components/nodata.vue